// import { allImagesPath } from "../../../lib/constants/ConstantsData";
// import { useNavigate } from "react-router-dom";

// const HeroSection = () => {
//   const navigate = useNavigate();

//   const handleCustomizeClick = () => {
//     navigate("/dashboard"); // Assuming your dashboard route is '/dashboard'
//   };

//   return (
//     <div className="relative bg-hero bg-cover bg-center bg-no-repeat min-h-[500px] lg:min-h-[500px] xl:min-h-[650px]">
//       {/* Text Section */}
//       <section className="w-full pt-6  text-center sm:pt-4 lg:pt-[40px] xl:pt-[50px] 2xl:pt-[20px]">
//         <h1 className="sm:full   mx-auto w-[80%] font-heading text-4xl  font-light leading-snug text-white sm:text-6xl sm:leading-snug md:text-6xl md:leading-snug min-[1023px]:mx-auto min-[1023px]:max-w-[80%] lg:text-[3rem] xl:p-[1.5rem] xl:text-[3.5rem] 2xl:text-[4.8rem]">
//           Music Inspired Design, Engineering and Manufacturing        </h1>
//         <p className="mt-6   w-[80%] mx-auto  mb-2 text-sm font-light text-white sm:mt-6 sm:text-xs md:text-sm lg:text-sm xl:mt-0 xl:text-base">
//           Guitar Pedal and Electronic Enclosure Manufacturing      </p>
//       </section>

//       {/* Upload Card - Overlapping */}
//       <div className="absolute left-1/2 top-[90%] z-10 w-full -translate-x-1/2 -translate-y-1/2 px-4 sm:top-full xl:top-[90%] xl:w-full">
//         <div className="mx-auto w-full max-w-[300px] rounded-xl border border-dashed bg-black p-4 text-center shadow-lg sm:max-w-md sm:p-5 md:max-w-lg lg:max-w-xl xl:max-w-2xl 2xl:max-w-4xl">
//           <div className="flex flex-col  items-center justify-center rounded-lg bg-[#121212] motion-preset-expand motion-duration-500
//   lg:py-8 xl:py-16">
//             <div className="flex flex-col py-2 items-center justify-center">
//               <p className="mb-2 px-2 py-2 text-sm font-bold text-white sm:text-xl lg:text-2xl  xl:text-2xl 2xl:text-3xl">
//                 Custom Parts, Built to Your Specs            </p>

//               <p className="mb-4 text-xs text-white sm:text-sm lg:text-base w-[50%]">
//                 We offers expert customization for precise, lasting product enhancement       </p>
//               <p className="mb-4 text-xs lg:text-sm w-[50%] text-[#777A82]">

//                 ObscuraMFG is a music inspired design, engineering and manufacturing company. Started in 2019 with the intent to provide unique musical products as well as enclosure services.
//               </p>
//             </div>


//               <button type="button" onClick={handleCustomizeClick} className=" lg:mt-10 xl:mt-12  lg:mb-2 flex items-center rounded-full bg-white px-8 mb-3 py-2 sm:px-14 sm:py-4  text-sm text-black hover:bg-gray-300">
//                 Customize & Get a Quote  </button>

//           </div>
//         </div>
//       </div>

//       {/* Decorative Ellipses */}
//       <img
//         className="absolute motion-preset-pop 
//  right-[20px] hidden lg:right-[50px] lg:top-[8rem] lg:block lg:h-[70px] lg:w-[70px] xl:right-[99px] xl:top-[170px] xl:h-[80px] xl:w-[80px] 2xl:right-[116px] 2xl:top-[140px] 2xl:h-[120px] 2xl:w-[130px]"
//         src={allImagesPath.rightEllips}
//         alt=""
//       />
//       <img
//         className="absolute motion-preset-pop 
//    left-[150px] hidden lg:bottom-[108px] lg:left-[81px] lg:block lg:h-[70px] lg:w-[70px] xl:bottom-[131px] xl:left-[144px] xl:h-[80px] xl:w-[80px] 2xl:bottom-[120px] 2xl:left-[144px] 2xl:h-[120px] 2xl:w-[130px]"
//         src={allImagesPath.leftEllips}
//         alt=""
//       />
//     </div>
//   );
// };

// export default HeroSection;


import { allImagesPath } from "../../../lib/constants/ConstantsData";
import { useNavigate } from "react-router-dom";

const HeroSection = () => {
  const navigate = useNavigate();

  const handleCustomizeClick = () => {
    navigate("/dashboard"); // Assuming your dashboard route is '/dashboard'
  };

  return (
    <div className="relative  min-h-[500px] lg:min-h-[500px] xl:min-h-[650px]">
      {/* Text Section */}
      <section className="w-full pt-6  text-center sm:pt-4 lg:pt-[40px] xl:pt-[50px] 2xl:pt-[20px]">
        {/* <h1 className=" w-full text-white font-heading uppercase leading-tight md:text-[56px] text-2xl"></h1> */}

        <h1 className="sm:full mx-auto w-[80%] font-heading text-4xl  font-light leading-snug text-white sm:text-5xl sm:leading-snug md:text-5xl md:leading-snug min-[1023px]:mx-auto min-[1023px]:max-w-[80%] lg:text-[3rem] xl:p-[1.5rem] xl:text-[3.5rem] 2xl:text-[4.8rem]">
          Premier Pedal Enclosure Manufacturing</h1>
        <p className="mt-6   w-[80%] mx-auto  mb-2 font-sfPro text-white sm:mt-6 text-xs md:text-sm lg:text-sm xl:mt-0 xl:text-base">
          And Custom Guitar Parts</p>
      </section>

      {/* Upload Card - Overlapping */}
      <div className="absolute left-1/2 top-[100%] sm:top-[98%] z-10 w-full -translate-x-1/2 -translate-y-1/2 px-4 sm:top-full xl:top-[90%] xl:w-full">
        <div className=" my-[10px] mx-auto w-full max-w-[400px] rounded-xl border border-dashed bg-black p-4 text-center shadow-lg sm:max-w-md sm:p-5 md:max-w-lg lg:max-w-xl xl:max-w-2xl 2xl:max-w-4xl">
          <div className="flex flex-col  items-center justify-center rounded-lg bg-[#121212] motion-preset-expand motion-duration-500 py-4 md:py-8 xl:py-16">
            <div className=" flex flex-col py-2 items-center justify-center">
              <p className="mb-2 px-2 py-2 text-sm font-sfPro font-bold text-white sm:text-xl lg:text-2xl  xl:text-2xl 2xl:text-3xl">
                Custom Enclosures, Built to Your Specs</p>
              <p className="mb-4 text-xs font-sfPro text-white sm:text-sm lg:text-base">
                Start with our drill/print templates or try our enclosure builder.</p>
            </div>


            <button type="button" onClick={handleCustomizeClick} className="md:mt-10 xl:mt-12 font-sfPro lg:mb-2 flex items-center rounded-full bg-white px-8 mb-3 py-2 sm:px-14 sm:py-4  text-sm text-black hover:bg-gray-300">
              Customize & Get a Quote  </button>

          </div>
        </div>
      </div>

      {/* Decorative Ellipses */}
      {/* <img
        className="absolute motion-preset-pop 
 right-[20px] hidden lg:right-[50px] lg:top-[8rem] lg:block lg:h-[70px] lg:w-[70px] xl:right-[99px] xl:top-[170px] xl:h-[80px] xl:w-[80px] 2xl:right-[116px] 2xl:top-[140px] 2xl:h-[120px] 2xl:w-[130px]"
        src={allImagesPath.rightEllips}
        alt=""
      />
      <img
        className="absolute motion-preset-pop 
   left-[150px] hidden lg:bottom-[108px] lg:left-[81px] lg:block lg:h-[70px] lg:w-[70px] xl:bottom-[131px] xl:left-[144px] xl:h-[80px] xl:w-[80px] 2xl:bottom-[120px] 2xl:left-[144px] 2xl:h-[120px] 2xl:w-[130px]"
        src={allImagesPath.leftEllips}
        alt=""
      /> */}
    </div>
  );
};

export default HeroSection;